import { render, staticRenderFns } from "./SorteoFreidora.vue?vue&type=template&id=4d3b5693&scoped=true&"
import script from "./SorteoFreidora.vue?vue&type=script&lang=js&"
export * from "./SorteoFreidora.vue?vue&type=script&lang=js&"
import style0 from "./SorteoFreidora.vue?vue&type=style&index=0&id=4d3b5693&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3b5693",
  null
  
)

export default component.exports